export default __webpack_public_path__ + "fda252abf351a4903001838c1eedce83.svg";